function emit(o, f) {
	ios.emit('a', o, f)
}

var ef = ''
function emitd(o, f) {
	var k = JSON.stringify(o)
	if (k != ef) {
		ef = k
		emit(o, f)
	}
}
